export const footerSections: any[] = [
  {
    id: 1,
    title: 'footer_legals',
    path: [
      { name: 'footer_legal_notice', url: '/legal-notice' },
      { name: 'footer_Terms_of_sale', url: '/terms' },
      { name: 'footer_Terms_of_use', url: '/terms-of-use' },
      { name: 'footer_privacy_policy', url: '/privacy' },
    ],
  },
  {
    id: 2,
    title: 'footer_company',
    path: [
      { name: 'footer_contact_us', url: '/contact-us' },
      { name: 'footer_imprint', url: '/imprint' },
      { name: 'footer_press', url: '/press' },
    ],
  },
  {
    id: 3,
    title: 'footer_faq',
    path: [
      { name: 'footer_account', url: '/accounts' },
      { name: 'footer_shipping', url: '/shipping' },
      { name: 'footer_orders', url: '/order' },
      { name: 'footer_payment', url: '/payment' },
      { name: 'footer_returns_and_exchanges', url: '/returns' },
    ],
  },
];

export const SelectedOptions: any[] = [
  { label: 'Random Complain', value: 'US' },
  { label: 'Shipment Complain', value: 'CA' },
  { label: 'Delivery Late', value: 'UK' },
  { label: 'Damaged Product', value: 'DE' },
  { label: 'Wrong Item Delivered', value: 'FR' },
  { label: 'Refund Request', value: 'AU' },
  { label: 'Payment Issue', value: 'IN' },
  { label: 'Customer Service Feedback', value: 'JP' },
];

export const Cities: any[] = [
  { label: 'New York', value: 'US' },
  { label: 'London', value: 'UK' },
  { label: 'Tokyo', value: 'JP' },
  { label: 'Sydney', value: 'AU' },
  { label: 'Paris', value: 'FR' },
  { label: 'Berlin', value: 'DE' },
  { label: 'Toronto', value: 'CA' },
  { label: 'Mumbai', value: 'IN' },
  { label: 'Dubai', value: 'AE' },
  { label: 'Cape Town', value: 'ZA' },
];

export const tabs = [
  { key: 'fit', label: 'Fit and description' },
  { key: 'details', label: 'Details' },
  { key: 'delivery', label: 'Delivery and Return' },
];
